<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑客户端' : '新增客户端'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      app_name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 名称 -->
      <a-form-item
        label="名称"
        app_name="app_name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.app_name" placeholder="请输入" />
      </a-form-item>
      <!-- 类型 -->
      <a-form-item
        label="类型"
        app_name="type"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-select
          v-model:value="formState.type"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option
            v-for="item in ClientTypes"
            :key="`${item.value}-${item.text}`"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 关联分类 -->
      <a-form-item
        v-if="formState.type !== 4"
        label="ID"
        app_name="app_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.app_id" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { ClientTypes } from '@/utils/constantList'
import { clientSave } from '@/api/request'
import Loading from '@/components/Loading'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(null)
// 版权方ID
let supplierId = ref(null)
// 表单数据
let formState = reactive({
  // 名称
  app_name: undefined,
  // 类型
  type: undefined,
  // id
  app_id: undefined
})
// 加载
let isLoading = ref(false)

// 打开抽屉
function showDrawer (params, supplierid) {
  // 展开
  visible.value = true
  // id
  supplierId.value = supplierid
  id.value = params.id
  // 赋值
  nextTick(() => {
    if (params.id) {
      formState.app_name = params.app_name
      formState.type = params.type
      formState.app_id = params.app_id
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    clientSave({
      supplier_id: supplierId.value,
      id: id.value,
      ...formState
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>